import { render, staticRenderFns } from "./ProductListingAccess.vue?vue&type=template&id=e80118ce&scoped=true"
import script from "./ProductListingAccess.vue?vue&type=script&lang=js"
export * from "./ProductListingAccess.vue?vue&type=script&lang=js"
import style0 from "./ProductListingAccess.vue?vue&type=style&index=0&id=e80118ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80118ce",
  null
  
)

export default component.exports